import { Col, Divider, Form, Input, Row } from "antd";

const MerchantOrganizationFormFields = () => (
  <>
    <Divider orientation="left" className="!mt-0">
      Байгууллага
    </Divider>
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          label="Байгууллагын нэр"
          name="name"
          rules={[{ required: true, message: "Нэр оруулна уу" }]}
        >
          <Input placeholder="Жишээ: Ривер Плаза ХХК" maxLength={80} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Байгууллагын регистр" name="register">
          <Input maxLength={10} placeholder="7 орон (заавал биш)" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Утас"
          name="phone"
          rules={[{ required: true, message: "Утас оруулна уу" }]}
        >
          <Input placeholder="99119911" maxLength={15} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Нэмэлт утас" name="phone2">
          <Input placeholder="Заавал биш" maxLength={15} />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item label="Байршил" name="address">
          <Input placeholder="Хаяг (заавал биш)" maxLength={100} />
        </Form.Item>
      </Col>
    </Row>

    <Divider orientation="left">Нэвтрэх</Divider>
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          label="Имэйл"
          name="email"
          extra="Мерчант порталд нэвтрэх нэр"
          rules={[
            { required: true, message: "Имэйл оруулна уу" },
            { type: "email", message: "Имэйл буруу байна" },
          ]}
        >
          <Input placeholder="merchant@company.mn" maxLength={80} />
        </Form.Item>
      </Col>
    </Row>
  </>
);

export default MerchantOrganizationFormFields;
